import Label from "Components/Common/components/Label";
import PdwDownload from "Components/GMS/Pdw/PdwDownload";
import React from "react";
import { Modal } from "react-bootstrap";

const TemplatePDW = (props) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
      show={props.showPopup}
      onHide={props.modalClose}
    >
      <Modal.Header closeButton>
        <div>
          <Label
            message={"Download Template"}
            fontSize={0.875}
            fontWeight="600"
          />
          <br />
          <Label
            message="Choose any category to download blank product template"
            fontSize={0.75}
            fontWeight="400"
            color="#5c5f62"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="m-2">
            <div className="row">
              {props.categoriesList === null ||
              props.categoriesList.length === 0 ? null : (
                <div className="row">
                  {props.categoriesList &&
                  props.categoryTypeList &&
                  Object.keys(props.categoriesList).length > 0 ? (
                    <PdwDownload
                      categoriesList={props.categoriesList}
                      categoryTypeList={props.categoryTypeList}
                      modalClose={props.modalClose}
                    />
                  ) : (
                    <p>No categories available to select</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TemplatePDW;
